import claimItem from './component/claimItem/texts.js';

export default {
  list: {
    header: {
      notes: 'Accordion header for warranty claims',
      message: 'Claims',
    },
    empty: {
      text: {
        notes: 'Text of empty state when no claims exist',
        message:
          'No warranty claims exists for the current selection. Select a single equipment and click the add button to create a claim!',
      },
    },
  },
  model: {
    claimStatus: {
      notes: 'Warranty claims status',
      message: 'Status',
      values: {
        draft: {
          notes: 'Claim status "Draft".',
          message: 'Draft',
        },
        submitted: {
          notes: 'Claim status "Submitted".',
          message: 'Submitted',
        },
        in_process: {
          notes: 'Claim status "In progress".',
          message: 'In progress',
        },
        final_decision: {
          notes: 'Claim status "Completed".',
          message: 'Completed',
        },
      },
    },
    claimType: {
      notes: 'Warranty claims type',
      message: 'Type',
      values: {
        unit: {
          notes: 'Claim type "Unit".',
          message: 'Unit',
        },
        part: {
          notes: 'Claim type "Spare part".',
          message: 'Spare part',
        },
      },
    },
    company: {
      notes: 'Warranty claims company',
      message: 'Company',
    },
    contactPerson: {
      notes: 'Warranty claims contact person',
      message: 'Contact person',
    },
    correctiveAction: {
      notes: 'Warranty claims corrective action',
      message: 'Corrective action',
    },
    correctiveDate: {
      notes: 'Warranty claims corrective date',
      message: 'Corrective date',
      validation: {
        fixedBeforeFailed: {
          notes: 'Validation message for corrective date before failure date',
          message: 'Corrective date may not be before failure date',
        },
      },
    },
    created: {
      notes: 'Warranty claims created date',
      message: 'Created',
    },
    creator: {
      notes: 'Warranty claims creator (username)',
      message: 'Creator',
    },
    currencyCode: {
      notes: 'Warranty claims currency code',
      message: 'Currency',
    },
    customerReference: {
      notes: 'Warranty claims customer reference',
      message: 'Customer reference ID',
    },
    deliveryPoint: {
      notes: 'Warranty claims delivery point',
      message: 'Delivery address',
    },
    failureCause: {
      notes: 'Warranty claims failure cause',
      message: 'Failure cause',
    },
    failureDate: {
      notes: 'Warranty claims failure date',
      message: 'Failure date',
      validation: {
        futureDate: {
          notes: 'Validation message for invalid future date',
          message: 'Failure date may not be a future date',
        },
      },
    },
    failureDescription: {
      notes: 'Warranty claims failure description',
      message: 'Failure description',
    },
    salesforceClaimId: {
      notes: 'Warranty claims claim id (originating from Salesforce)',
      message: 'Claim ID',
    },
    serialNumber: {
      notes: 'Warranty claims equipment serial number',
      message: 'Serial number',
    },
    verdict: {
      notes: 'Warranty claims verdict',
      message: 'Verdict',
      values: {
        fully_accepted: {
          notes: 'Claim verdict "Fully accepted".',
          message: 'Fully accepted',
        },
        partially_accepted: {
          notes: 'Claim verdict "Partially accepted".',
          message: 'Partially accepted',
        },
        rejected: {
          notes: 'Claim verdict "Rejected".',
          message: 'Rejected',
        },
      },
    },
    verdictDecisionComment: {
      notes: 'Claim verdict comment',
      message: 'Comments',
    },
    verdictDecisionDate: {
      notes: 'Claim verdict decision date',
      message: 'Date',
    },
    verdictDecisionReason: {
      notes: 'Claim verdict reason',
      message: 'Decision reason',
    },
    workHours: {
      notes: 'Warranty claims work hours',
      message: 'Work hours at failure date',
    },
  },
  dialog: {
    action: {
      saveDraft: {
        notes: 'Title for action Save draft',
        message: 'Save draft',
      },
      submit: {
        notes: 'Title for action Submit',
        message: 'Submit',
      },
    },
  },
  details: {
    generalInformation: {
      header: {
        notes: 'Header for dialog step General information',
        message: 'General information',
      },
      claim: {
        header: {
          notes: 'Header for accordion Claim',
          message: 'Claim',
        },
      },
      equipment: {
        header: {
          notes: 'Header for accordion Equipment for a claim',
          message: 'Equipment',
        },
      },
    },
    customerInformation: {
      header: {
        notes: 'Header for dialog step Customer information',
        message: 'Customer information',
      },
      equipmentOwner: {
        header: {
          notes: 'Header for accordion Equipment owner for a claim',
          message: 'Equipment owner',
        },
      },
      claimer: {
        header: {
          notes: 'Header for accordion Claimer for a claim',
          message: 'Claimer',
        },
      },
    },
    failureInformation: {
      header: {
        notes: 'Header for dialog step Failure information',
        message: 'Failure information',
      },
      claimContent: {
        header: {
          notes: 'Header for accordion Claim content for a claim',
          message: 'Claim content',
        },
      },
    },
    grandTotal: {
      header: {
        notes: 'Header for accordion Grand total for a claim',
        message: 'Grand total',
      },
      item: {
        notes: 'Header column Item for Grand total for a claim',
        message: 'Item',
      },
      grandTotalClaimed: {
        notes: 'Title for Grand total claimed for a claim',
        message: 'Grand total claimed',
      },
    },
    attachments: {
      header: {
        notes: 'Header for accordion Attachments for a claim',
        message: 'Attachments',
      },
      unsupportedFileType: {
        notes: 'Unsupported file type for uploaded claim attachment',
        message: 'Unsupported file type',
      },
      maxFileSizeExceeded: {
        notes: 'The selected file was larger than allowed',
        message: 'The maximum file size allowed is {{size}} megabyte',
      },
      validationError: {
        notes:
          'Validation error message indicating that the chosen claim attachments are invalid',
        message: 'You must upload at least two attachments',
      },
      downloadFailed: {
        notes: 'Error message if download attachment fails.',
        message: 'Download attachment failed',
      },
    },
    summary: {
      header: {
        notes: 'Header for dialog step Summary',
        message: 'Summary',
      },
    },
    verdict: {
      header: {
        notes: 'Header accordion Verdict for a claim',
        message: 'Verdict',
      },
      inProgress: {
        notes:
          'Title for a chip indicating that a claim verdict is in progress',
        message: 'In progress',
      },
    },
  },
  claimItem,
};
